export default __webpack_public_path__ + "static/media/sidebar.53f07582.jpg";